import Autoplay from "embla-carousel-autoplay";
import React, { FC } from "react";
import bg_home from "../../images/backgrounds/bg-home.png";
import { Button } from "../ui/button";
import { Carousel, CarouselContent, CarouselItem } from "../ui/carousel";

interface HomeSectionProps {
  className?: string;
  children?: React.ReactNode;
}
const HomeSection: FC<HomeSectionProps> = ({ className = "", children }) => {
  const bgImages = [
    { id: "1", image: bg_home },
    { id: "2", image: bg_home },
    { id: "3", image: bg_home },
  ];

  return (
    <>
      <div className="relative p-24 mt-10">
        <div className="absolute inset-0">
          <Carousel
            opts={{ loop: true }}
            plugins={[
              Autoplay({
                delay: 2000,
              }),
            ]}
          >
            <CarouselContent>
              {bgImages.map((slider) => (
                <CarouselItem key={slider.id}>
                  <img
                    src={slider.image}
                    alt={`Carousel Image ${slider.id}`}
                    style={{ height: "700px", width: "100%" }}
                  />
                </CarouselItem>
              ))}
            </CarouselContent>
            <div></div>
          </Carousel>
        </div>
      </div>

      {/* Full-width background section */}
      <div className="relative bg-gradient-to-r from-secondary via-secondary/95 to-secondary overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute top-0 left-0 w-64 h-64 bg-white/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl translate-x-1/2 translate-y-1/2"></div>

        {/* Wave pattern */}
        <div className="absolute inset-0 opacity-10">
          <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path fill="currentColor" fillOpacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,112C672,96,768,96,864,112C960,128,1056,160,1152,160C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
          </svg>
        </div>

        <div className="relative z-10 py-6 px-6 pb-10">
          <div className="max-w-5xl mx-auto">
            {/* Title with animation */}
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center text-white mb-6 leading-tight">
              Des acteurs du cycle de l'eau
            </h1>

            {/* Decorative line */}
            <div className="flex items-center justify-center gap-3 mb-8">
              <div className="h-1 w-16 bg-white/30 rounded-full"></div>
              <div className="w-3 h-3 bg-white rounded-full"></div>
              <div className="h-1 w-16 bg-white/30 rounded-full"></div>
            </div>

            {/* Description */}
            <div className="text-center space-y-2 mb-10">
              <p className="text-base md:text-lg text-white/95 leading-relaxed">
                Eaux Seine Ouest regroupe deux établissement publics territoriaux qui
              </p>
              <p className="text-base md:text-lg text-white/95 leading-relaxed">
                interviennent de façon complémentaire dans l'intégralité du petit cycle de
              </p>
              <p className="text-base md:text-lg text-white/95 leading-relaxed">
                l'eau dans les Yvelines et les Hauts-de-Seine
              </p>
            </div>

            {/* Buttons */}
            <div className="hidden md:flex items-center justify-center gap-8 mt-12">
              {/* HYDREAULYS Button */}
              <button
                className="group relative px-12 py-6 bg-gradient-to-r from-primary to-primary/80 text-white font-bold uppercase rounded-2xl overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-primary/50"
                onClick={() =>
                  window.open(
                    process.env.REACT_APP_HYDREAULYS_URL || "/",
                    "_blank"
                  )
                }
              >
                {/* Shine effect */}
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>

                {/* Content */}
                <div className="relative flex items-center gap-3">
                  <span className="text-lg tracking-wide">Hydreaulys</span>
                  <svg
                    className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    />
                  </svg>
                </div>
              </button>

              {/* AQUAVESC Button */}
              <button
                className="group relative px-12 py-6 bg-white text-secondary font-bold uppercase rounded-2xl overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-white/50 border-2 border-white"
                onClick={() =>
                  window.open(
                    process.env.REACT_APP_AQUAVESC_URL || "/",
                    "_blank"
                  )
                }
              >
                {/* Shine effect */}
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-secondary/10 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>

                {/* Content */}
                <div className="relative flex items-center gap-3">
                  <span className="text-lg tracking-wide">Aquavesc</span>
                  <svg
                    className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    />
                  </svg>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeSection;
